(function($) {  

  let $shortcodeC = $('.ShortCode.CourseFeatures .Certificate ')
  if($shortcodeC.length) { 

    $shortcodeC = $shortcodeC.eq(0)

    $shortcodeC
    .on(
      'click',
      function() {

        const url = `/wp-json/academy/certificate/download?courseid=${ window.academystatus.postid }&userid=${ window.academystatus.userid }&locale=${ window.academystatus.locale }`
        
        window.open(url);

        return false;
      }
    )
  } 

  const $downloadcertificate = $('.ShortCode.ListCourses .Course .CourseProgress .Certificate')
  if($downloadcertificate.length) { 

    $downloadcertificate
    .on(
      'click',
      function() {

        const courseid = $(this).data('courseid')

        const url = `/wp-json/academy/certificate/download?courseid=${ courseid }&userid=${ window.academystatus.userid }&locale=${ window.academystatus.locale }`

        window.open(url);

        return false;
      }
    )
  }

})(jQuery)